module.exports = __webpack_public_path__ + "static/media/ds-solar-logo.7ff6db2d.png";